/**
 * Name: Editor
 */

import suneditor from 'suneditor';
import list from 'suneditor/src/plugins/submenu/list';
import link from 'suneditor/src/plugins/dialog/link';
import lang from 'suneditor/src/lang';

export default class Editor {
  constructor (element) {
    this.element = element;
  }

  mount () {
    this.editor = suneditor.create(
      this.element,
      {
        plugins: [list, link],
        lang: lang.fr,
        buttonList: [
          ['undo', 'redo'],
          ['bold', 'italic', 'superscript'],
          ['link'],
        ],
      },
    );

    this.editor.onChange = () => {
      this.editor.save();
    };
  }

  unmount () {
    this.editor.destroy();
    this.editor = null;
  }
}
